export default __webpack_public_path__ + "static/media/mesi_taxitita_astikou_diktiou_big.233de26a.svg";